import script from "./TournamentUseCases.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentUseCases.vue?vue&type=script&setup=true&lang=js"

import "./TournamentUseCases.vue?vue&type=style&index=0&id=56b8a0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b8a0c2"]])

export default __exports__